module.exports = {
    game: "好玩"
}